import * as React from "react";
import { useMemo } from "react";
import { styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import {
  MobileView,
  NavigationPanelBreakPoint,
  SingleViewPerLayoutBreakPoint,
} from "../../../util/aKaunGeneralUtil";
import { Footer } from "../rosebud/footer";
import { scrollableStyle } from "fe-common/ui/commonStyles";
import { RosebudMobileBottomNavigationHeight } from "../common/rosebudButtomNavigationButton";
import { AgentNavBarHeight } from "../agentTopNavigation";
import { WhoAreYouContent } from "./whoAreYou/whoAreYouContent";
import { StartOverContent } from "./welcomeBack/startOverContent";
import { WelcomeBackTopSection } from "./welcomeBack/welcomeBackTopSection";
import { WhoAreYouTopSection } from "./whoAreYou/whoAreYouTopSection";
import { readFromGlobalStorage } from "fe-web-components/userStorage/globalUserStorage";
import { UserStorageKey } from "fe-web-components/userStorage/userStorageKey";

//region [[ Styles ]]
const WelcomeScreenViewMainContainer = styled("div")(({ theme }) => ({
  display: "flex",
  background: KahunColorMap.White,
  // Break the default padding by setting a new fixed 100%X100% container
  position: "fixed",
  top: `${AgentNavBarHeight - 5}px`,
  right: 0,
  width: "100%",
  height: "100%",
  [theme.breakpoints.down(MobileView)]: {
    justifyContent: "space-evenly",
    marginBottom: `-${RosebudMobileBottomNavigationHeight}px`,
    paddingBottom: "50px",
  },
}));

const WelcomeScreenBoxScroll = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  width: "100%",
  [theme.breakpoints.up(SingleViewPerLayoutBreakPoint)]: {
    // Inside the container, put a box to allow scrolling overflown items,
    // make it relative so that 100% height will address to it, and not to the older tree
    // so it could expand
    position: "relative",
    ...scrollableStyle,
  },
}));

const WelcomeScreenView = styled("div")(({ theme }) => ({
  ...scrollableStyle,
  display: "flex",
  flexFlow: "column",
  width: "100%",
  boxSizing: "content-box",
  height: "100%",
  // paddingBottom: "140px",
  justifyContent: "space-between",
  [theme.breakpoints.down(MobileView)]: {
    paddingBottom: 0,
  },
  [theme.breakpoints.up(SingleViewPerLayoutBreakPoint)]: {
    // inside the overflown box allow fitting the content
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    background: "white",
    paddingBottom: "110px", // keep space for footer
  },
}));

export const WIDE_DESKTOP = 1500;

const TopTitleSection = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  width: "100%",
  [theme.breakpoints.down(NavigationPanelBreakPoint)]: {
    width: "75%",
  },
  [theme.breakpoints.up(WIDE_DESKTOP)]: {
    width: "55%",
  },
  [theme.breakpoints.down(MobileView)]: {
    textAlign: "center",
    width: "100%",
  },
}));

const ContentSection = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  boxSizing: "border-box",
  width: "100%",
  height: "100%",
  padding: "15px",
  backgroundColor: KahunColorMap.AccentLight,
  borderTopRightRadius: "25px",
  borderTopLeftRadius: "25px",
}));

const WelcomeScreenFooter = styled(Footer)(({ theme }) => ({
  boxShadow: "rgb(0 0 0 / 8%) 0px -2px 8px",
  height: "auto",
  [theme.breakpoints.down(MobileView)]: {
    display: "none",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface WelcomeScreenProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

//region [[ Texts ]]

//endregion [[ Texts ]]

export const WelcomeScreen = ({ ...props }: WelcomeScreenProps) => {
  const userDidIdentify =
    !!readFromGlobalStorage(UserStorageKey.Speciality) &&
    readFromGlobalStorage(UserStorageKey.Speciality) !== "null";

  const whoAreYou = useMemo(() => !userDidIdentify, [userDidIdentify]);

  return (
    <WelcomeScreenViewMainContainer className={"landing-page-container"}>
      <WelcomeScreenBoxScroll>
        <WelcomeScreenView className={"welcome-screen-view"}>
          <TopTitleSection className={"top-title-section"}>
            {whoAreYou ? <WhoAreYouTopSection /> : <WelcomeBackTopSection />}
          </TopTitleSection>
          <ContentSection className={"content-section"}>
            {whoAreYou ? <WhoAreYouContent /> : <StartOverContent />}
          </ContentSection>
          <WelcomeScreenFooter />
        </WelcomeScreenView>
      </WelcomeScreenBoxScroll>
    </WelcomeScreenViewMainContainer>
  );
};
